import { trimStart } from 'lodash';
import { getOuterUrl } from './get-outer-url';
import { readableUrl } from './uri';
export const encodeQuery = (query) => encodeURIComponent(query.toLowerCase().replace(/#/g, '.hash.'));
export const decodeQuery = (query) => decodeURIComponent(query).replace(/\.hash\./g, '#');
export const createHashtagPath = (decoratedText, { newPath = false } = {}) => {
    const hashtagSlug = trimStart(decoratedText, '#');
    const hashtag = newPath ? hashtagSlug : `#${hashtagSlug}`;
    return readableUrl(newPath ? `/hashtags/${encodeURIComponent(hashtag)}` : `/search/${encodeQuery(hashtag)}`);
};
export const createHashtagHref = (decoratedText, sectionUrl, { newPath = false } = {}) => getOuterUrl(createHashtagPath(decoratedText, { newPath }), sectionUrl);
export const createAMPHashtagHref = (sectionUrl, { newPath = false } = {}) => (decoratedText) => getOuterUrl(createHashtagPath(decoratedText, { newPath }), sectionUrl);
//# sourceMappingURL=search-page-url.js.map